import {combine} from 'effector';

import {
    createCustoms,
    fetchPagedCustomsList,
    removeCustoms,
    updateCustoms,
} from 'api/profile/customs';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';

import {Customs, CustomsPaginationContent} from 'types/profile';

const domain = rootDomain.createDomain('CustomsGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchCustomsGridFx',
    handler: fetchPagedCustomsList,
});

export const createCustomsFx = domain.createEffect({
    name: 'createCustomsFx',
    handler: createCustoms,
});

export const updateCustomsFx = domain.createEffect({
    name: 'updateCustomsFx',
    handler: updateCustoms,
});

export const removeCustomsFx = domain.createEffect({
    name: 'removeCustomsFx',
    handler: removeCustoms,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const data$ = domain.createStore<CustomsPaginationContent | null>(null);

export const searchChanged = domain.createEvent<string>();
export const search$ = domain.createStore('').on(searchChanged, (_, value) => value);

export const onSetEditCustoms = domain.createEvent<Customs>();
export const editCustomsData$ = domain.createStore<Customs | null>(null);

export const tableState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    search: search$,
    dataLoading: fetchDataFx.pending,
});
